import React, {
    useState,
    useEffect
} from "react";
import {
    Row,
    Table,
    OverlayTrigger,
    Tooltip
} from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { updateTotalForFootnote } from "./FootnotesHelperFunctions";

export const FootnoteGrid = (grid_props) => {
    const [rowData, setRowData] = useState(grid_props.rowData)
    const [header, setHeader] = useState(grid_props.header)

    useEffect(() => {
        if (grid_props.rowData !== undefined) {
            setRowData(grid_props.rowData)
        }
        console.log("ROW DATA: ", grid_props.rowData)
    }, [grid_props.rowData])

    useEffect(() => {
        if (grid_props.header !== undefined) {
            setHeader(grid_props.header)
        }
        console.log("HEADER: ", grid_props.header)
    }, [grid_props.header])

    const updateField = (index, event) => {
        // if (event.key === "Enter") {
        // setValue(event.target.value)
        const rd = [...rowData]
        rd[index]["amount"] = event.target.value.toLocaleString()
        const newRd = updateTotalForFootnote(rd)
        setRowData(newRd)
        grid_props.updateddata(newRd)
        // }
    }
    const [showTooltip, setShowTooltip] = useState(false);
    const [copiable, setCopiable] = useState(false)
    const [target, setTarget] = useState(null);
    const handleCopyClick = (value, event) => {
        // Create a temporary textarea element
        const tempTextarea = document.createElement('textarea');
        tempTextarea.value = value;
        document.body.appendChild(tempTextarea);

        // Select the text in the textarea
        tempTextarea.select();
        tempTextarea.setSelectionRange(0, 99999); // For mobile devices

        // Copy the text to the clipboard
        document.execCommand('copy');

        // Remove the temporary textarea
        document.body.removeChild(tempTextarea);
        // Show tooltip
        setTarget(event.target);
        setShowTooltip(true);

        // Hide tooltip after 3 seconds
        setTimeout(() => {
            setShowTooltip(false);
        }, 2000); // Adjust the duration as needed (2000ms = 2 seconds)
    };

    const updateSelection = (event, index) => {
        const rd = [...rowData]
        rd[index]["selected"] = event.target.checked
        const newRd = updateTotalForFootnote(rd)
        setRowData(newRd)
        grid_props.updateddata(newRd)
    }

    return (
        <>
            <Row className="no-gutter text-center" style={{ marginBottom: 15 }}>
                <h5>{header !== undefined && header !== null ? header.split(" - ")[0].split(".")[1] : "Field"}</h5>
            </Row>
            <Table hover style={{ overflowY: "auto" }}>
                <tbody>
                    {
                        rowData.map((row, index) => (
                            row["field"].length > 200 ? <></> :
                                (
                                    <tr>
                                        <td style={{ borderBottom: 0, fontSize: 10, textAlign: "right" }}>
                                            {
                                                /\d\./.test(row["field"])
                                                    ?
                                                    <div className="flex-row-center-space">
                                                        <input
                                                            type="checkbox"
                                                            className={"form-check-input move-left custom-check-input"}
                                                            checked={row["selected"]}
                                                            onChange={event => updateSelection(event, index)}
                                                            autoComplete="new-password"
                                                        />
                                                        <b style={{ textDecoration: "underline" }}>LINE {row["field"].split(".")[0]} - {row["field"].split(".")[1].toUpperCase()}</b>
                                                    </div>
                                                    :
                                                    row["field"].toLowerCase().includes("total") ?
                                                        <div className="flex-row-center-space">
                                                            <b>{row["field"].toUpperCase()}</b>
                                                        </div>
                                                        :
                                                        /[a-zA-Z] - /.test(row["field"])
                                                            ?
                                                            <div className="flex-row-center-space">
                                                                <input
                                                                    type="checkbox"
                                                                    className={"form-check-input move-left custom-check-input"}
                                                                    checked={row["selected"]}
                                                                    onChange={event => updateSelection(event, index)}
                                                                    autoComplete="new-password"
                                                                />
                                                                <p style={{ textDecoration: "underline" }}>{row["field"]}</p>
                                                            </div>
                                                            :
                                                            <div className="flex-row-center-space">
                                                                <input
                                                                    type="checkbox"
                                                                    className={"form-check-input move-left custom-check-input"}
                                                                    checked={row["selected"]}
                                                                    onChange={event => updateSelection(event, index)}
                                                                    autoComplete="new-password"
                                                                />
                                                                {row["field"]}
                                                            </div>
                                            }
                                        </td>
                                        <td style={row["field"].toLowerCase().includes("total") ? { borderBottom: "1px dashed black", borderTop: "1px dashed black", textAlign: "right", fontSize: 10 } : { border: "0px", textAlign: "right", fontSize: 10 }}>
                                            {
                                                row["amount"] !== "" ?
                                                    (!row["field"].toLowerCase().includes("total")
                                                        ?
                                                        <div className="flex-row-center-center">
                                                            <input type="text"
                                                                className={
                                                                    "grid-kone-text-field"
                                                                }
                                                                value={row["amount"]}
                                                                onChange={(event) =>
                                                                    updateField(index, event)
                                                                    // setValue(event.target.value)
                                                                    // console.log()
                                                                }
                                                                // onBlur={(event) => updateField(index, event)}
                                                                autoComplete="new-password"
                                                                style={{ marginRight: 4 }}
                                                            />
                                                            {copiable ? <OverlayTrigger
                                                                trigger={"click"}
                                                                placement="top"
                                                                show={showTooltip}
                                                                overlay={
                                                                    <Tooltip style={{ zIndex: 10001 }} id={`tooltip-${row["field"]}`}>
                                                                        Copied
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <Icon.ClipboardFill onClick={(event) => handleCopyClick(row["amount"], event)} style={{ cursor: 'pointer', color: "gray", fontSize: 12, zIndex: 1 }} />
                                                            </OverlayTrigger> : <></>}
                                                        </div>
                                                        :
                                                        <>
                                                            <div className="flex-row-center-center">
                                                                <div style={{ textAlign: "right", fontWeight: 700, width: "100%", marginRight: 16 }}>
                                                                    {row["amount"]}
                                                                </div>
                                                                {copiable ? <OverlayTrigger
                                                                    trigger={"click"}
                                                                    placement="top"
                                                                    show={showTooltip}
                                                                    overlay={
                                                                        <Tooltip style={{ zIndex: 10001 }} id={`tooltip-${row["field"]}`}>
                                                                            Copied
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <Icon.ClipboardFill onClick={(event) => handleCopyClick(row["amount"], event)} style={{ cursor: 'pointer', color: "gray", fontSize: 12, zIndex: 1 }} />
                                                                </OverlayTrigger> : <></>}
                                                            </div>
                                                        </>
                                                    )
                                                    :
                                                    <div className="flex-row-center-center">
                                                        <input type="text"
                                                            className={
                                                                "grid-kone-text-field"
                                                            }
                                                            value={row["amount"]}
                                                            onChange={(event) =>
                                                                updateField(index, event)
                                                                // setValue(event.target.value)
                                                                // console.log()
                                                            }
                                                            // onBlur={(event) => updateField(index, event)}
                                                            autoComplete="new-password"
                                                            style={{ marginRight: 4 }}
                                                        />
                                                        {copiable ? <OverlayTrigger
                                                            trigger={"click"}
                                                            placement="top"
                                                            show={showTooltip}
                                                            overlay={
                                                                <Tooltip style={{ zIndex: 10001 }} id={`tooltip-${row["field"]}`}>
                                                                    Copied
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <Icon.ClipboardFill onClick={(event) => handleCopyClick(row["amount"], event)} style={{ cursor: 'pointer', color: "gray", fontSize: 12, zIndex: 1 }} />
                                                        </OverlayTrigger> : <></>}
                                                    </div>
                                            }
                                        </td>
                                    </tr>
                                )
                        ))
                    }
                </tbody>
            </Table>
        </>
    );
};